import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListCareLinePriorityResponse } from '../../responses/care-line-priority/list-care-line-priority.response';

@Injectable({
  providedIn: 'root'
})
export class GetCareLinePriorityService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public getAllByIdHealthUnit(): Observable<ListCareLinePriorityResponse> {
    return this.httpClient.get<ListCareLinePriorityResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApicareLinePriority) + `GetCareLinePriority/getAllByIdHealthUnit`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}